import userService from "@/services/userService"

export const onlineMeetingTemplate = {
  id: "online_meeting",
  title: "Online Meeting",
  icon: "mdi-microsoft-teams",
  color: "#6264A7",
  duration: 30,
  type: "appointment",
  specialType: "online_meeting",
  requiresCustomer: true,
}

export const isOnlineMeeting = (value) => Boolean(value && (value.specialType === "online_meeting" || value.templateId === "online_meeting" || value.id === "online_meeting"))
export const availableMeetingTemplates = (items) => (items || []).filter((item) => !isOnlineMeeting(item) || userService.hasRight("stat_admin"))
